import React from "react";
import { Link } from "react-router-dom";
import { Leaf, Phone, Instagram, Mail } from "lucide-react";
import { SITE } from "../data/site";

export const Footer = ({ onBook }) => (
  <footer className="bg-[#222F17] text-[#C9DFAC] pt-16 pb-8">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="grid md:grid-cols-3 gap-10 pb-12 border-b border-white/10">
        <div>
          <div className="flex items-center gap-3">
            <span className="grid place-items-center w-9 h-9 rounded-full bg-[#F2F8E8] text-[#3A7D32]"><Leaf size={17} /></span>
            <span className="brand-script text-3xl sm:text-4xl">Serene Mind Place</span>
          </div>
          <p className="mt-4 text-sm max-w-xs leading-relaxed">A warm, unjudgmental counselling space led by {SITE.therapist} in Jubilee Hills, Hyderabad.</p>
        </div>
        <div>
          <div className="overline text-[#FFC9A0]">Explore</div>
          <div className="mt-4 flex flex-col gap-2 text-sm">
            {["about", "services", "manifesto", "reviews", "contact"].map((id) => (
              <button key={id} onClick={() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" })} className="text-left hover:text-[#F2F8E8] transition-colors capitalize">{id}</button>
            ))}
          </div>
        </div>
        <div>
          <div className="overline text-[#FFC9A0]">Get in touch</div>
          <div className="mt-4 flex flex-col gap-3 text-sm">
            <a href={`tel:${SITE.phoneTel}`} className="flex items-center gap-2 hover:text-[#F2F8E8]"><Phone size={14} /> {SITE.phone}</a>
            <a href={`mailto:${SITE.email}`} className="flex items-center gap-2 hover:text-[#F2F8E8] break-all"><Mail size={14} /> {SITE.email}</a>
            <a href={SITE.instagram} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-[#F2F8E8]"><Instagram size={14} /> {SITE.instagramHandle}</a>
            <button onClick={onBook} className="mt-2 self-start rounded-full bg-[#F2F8E8] text-[#3A7D32] px-5 py-2.5 text-sm hover:bg-[#FFC9A0] transition-colors">Book a Consultation</button>
          </div>
        </div>
      </div>
      <div className="pt-6 flex flex-col sm:flex-row justify-between gap-3 text-xs text-[#93AC79]">
        <span>© {new Date().getFullYear()} Serene Mind Place Counselling. All rights reserved.</span>
        <Link to="/admin" data-testid="footer-admin-link" className="hover:text-[#F2F8E8] transition-colors">Practitioner Login</Link>
      </div>
    </div>
  </footer>
);
